import infoPopupComponent from './infoPopup.component';
import popupModule from '../index';

const infoPopupModule = angular.module('app.common.ertInfoPopup', [popupModule])
	.component('ertInfoPopup', infoPopupComponent)
	.name;

export default infoPopupModule;
